export default __webpack_public_path__ + "static/media/ios-icon.4d44ee0c.png";